export default __webpack_public_path__ + "static/media/IconDesc_CaneEquipment.256.4a9a92d7.png";